import { render, staticRenderFns } from "./EventOrder.vue?vue&type=template&id=a3036f12&scoped=true&"
import script from "./EventOrder.vue?vue&type=script&lang=js&"
export * from "./EventOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3036f12",
  null
  
)

export default component.exports